import { useHealthStore } from '@/stores/healthStore'

/**
 * True unless the device is known to be offline (browser `offline` event, or
 * two requests in a row that got no response). Driven by the single poller in
 * App.tsx — this hook never polls.
 *
 * Use it to disable mutations with a reason instead of letting them fail:
 *
 *   const online = useOnline()
 *   <button disabled={!online}>Send text</button>
 *   {!online && <p className="text-xs text-white/70">You're offline. Send when you're back online.</p>}
 */
export function useOnline(): boolean {
  return useHealthStore((s) => s.status !== 'offline')
}

/** Online flag plus the last time the API answered (for "Updated 10:42" markers). */
export function useNetworkStatus(): { online: boolean; lastSuccess: number | null } {
  const online = useHealthStore((s) => s.status !== 'offline')
  const lastSuccess = useHealthStore((s) => s.lastSuccess)
  return { online, lastSuccess }
}
